<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pa-4">
    <v-col cols="12" xs="12" sm="8" class="pt-0 py-0" v-if="showTitle">
      <span class="headline">Netzwerke</span>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="12" xs="12" sm="4"  >
      <v-text-field
          v-model="search"
          append-icon="search"
          label="Suche"
          single-line
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" xs="12">
    <v-data-table
        :items-per-page="-1"
        :headers="headers"
        :items="deviceList"
        :search="search"
        fixed-header
        show-select
        v-model="selected"
        :height="tableHeight"
        @click:row="editItem"
        hide-default-footer
    >

      <template v-slot:item.name="{ item }">
        <v-icon v-if="item.isMother">business</v-icon>
        <span v-if="isOpenAllowed(item)" class="handpointer" @click="editItem(item)">{{item.name}}</span>
        <span v-else>{{item.name}}</span>
      </template>
      <template v-slot:item.address="{ item }">
        <span v-if="isOpenAllowed(item)" class="handpointer" @click="editItem(item)">{{item.street}}<br>{{item.postcode}} {{item.city}}</span>
        <span v-else>{{item.street}}<br>{{item.postcode}} {{item.city}}</span>
      </template>      <template v-slot:item.company="{ item }">
            <span :style="getCompanyStyle(item)">
              {{item.company}}
              <span v-if="!item.company" class="handpointer" @click="openCompanyDialog(item)">zuweisen</span>
            </span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon
            small
            v-if="isEditAllowed(item)"
            class="mr-2"
            @click="editItem(item)"
        >
          edit
        </v-icon>
        <v-icon
            v-if="isRemoveAllowed(item)"
            small
            @click="deleteItem(item)"
        >
          delete
        </v-icon>
      </template>
    </v-data-table>
    </v-col>
    <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";

export default {
  name: 'TableSelCompanies',
  props: {
    showTitle: Boolean,
    companyId: String
  },
  components: {DialogDeleteItem},
  data () {
    return {
      tableHeight: 200,
      currentDevice: null,
      search: null,
      selected: [],
      headers: [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Adresse', value: 'address'},
        /*{text: 'Strasse', value: 'street'},
        {text: 'PLZ', value: 'postcode'},
        {text: 'Stadt', value: 'city'},*/
        {text: 'E-Mail', value: 'email'},
        {text: 'Telefon', value: 'phonenumber'},
        /*{text: 'Aktion', value: 'action'}
        {text: 'Erstellt', value: 'created'},
        {text: 'Kommentar', value: 'comment'}
         */
      ],
      deviceList: []
    }
  },
  watch: {
    selected: function(newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    resize: function () {
      this.tableHeight = window.innerHeight - 416;
      if (this.showTitle) {
        this.tableHeight = window.innerHeight - 416;
      }
      if (this.tableHeight < 150) {
        this.tableHeight = 150;
      }
    },
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Netzwerk',
        id: '' + item.guid,
        name: 'Netzwerk ' + item.name,
        item: item
      })
    },
    doDelete: function (item) {
      console.log('item', item)
      Vue.prototype.$apiCompany.deleteCompany(item.item.guid, this.reload)
    },
    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.currentDevice = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie ein Netzwerk'
      })
    },
    isEditAllowed: function (item) {
      var ownAllowed = Vue.prototype.$apiRight.hasRight('RIGHT_NETWORK_OPEN_OWN')

      return Vue.prototype.$apiRight.hasRight('RIGHT_NETWORK_OPEN_OTHER', {
        orClausel: ownAllowed && (item.guid === Vue.prototype.$api.getCredentials().data.guidParent)
      })
    },
    isRemoveAllowed: function (item) {
      var ownAllowed = Vue.prototype.$apiRight.hasRight('RIGHT_NETWORK_DELETE_OWN')
      return Vue.prototype.$apiRight.hasRight('RIGHT_NETWORK_DELETE_OTHER', {
        orClausel: ownAllowed && (item.guid === Vue.prototype.$api.getCredentials().data.guidParent)
      })
    },
    isOpenAllowed: function (item) {
      var ownAllowed = Vue.prototype.$apiRight.hasRight('RIGHT_NETWORK_OPEN_OWN')
      return Vue.prototype.$apiRight.hasRight('RIGHT_NETWORK_OPEN_OTHER', {
        orClausel: ownAllowed && (item.guid === Vue.prototype.$api.getCredentials().data.guidParent)
      })
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkDeviceToCompany(this.currentDevice.guid, item, this.reload)
    },
    editItem: function (item) {
      this.$router.push('/Netzwerke/' + item.guid)
    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    reload: function () {
      var reqData = {
        isMother: 1
      }
      if (!Vue.prototype.$apiRight.hasRight('RIGHT_NETWORK_VISIBLE_OTHER')) {
        reqData.guid = Vue.prototype.$api.getCredentials().data.guidParent
      }

      Vue.prototype.$apiCompany.loadCompanies(reqData, this.onGetData)
    },
    onGetData: function (result) {
      console.log('result', result)
      this.deviceList = result
    }
  },
  mounted () {
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
    this.resize()
  },
  created() {
    Vue.prototype.$eventHub.$on('resize', this.resize)

  },
  destroyed() {
    Vue.prototype.$eventHub.$off('resize', this.resize)
  },
}
</script>

<style scoped>

</style>
